import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { IAppDataModel, IYearData, YearData } from '@app/@appstate/appdata.model';

import { AppDataQuery } from '@app/@appstate/appdata.query';
import { AppDataService } from '@app/@appstate/appdata.service';
import { AuthQuery } from '@app/auth/auth.query';
import { AuthDataService } from '@app/auth/auth-data.service';

import { Observable } from 'rxjs';

import { ConfirmationService } from 'primeng/api';

import { MatSnackBar } from '@angular/material/snack-bar';

import { JournalService } from '@app/@core';
import { SettingsService, Settings } from '@app/services/settings.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
})
export class SettingsComponent implements OnInit {
  settings: Settings;

  frmVSettings: UntypedFormGroup;
  passwordForm: UntypedFormGroup;
  generalSettingsForm: UntypedFormGroup;
  
  profileImageUrl: string | null = null;
  selectedFile: File | null = null;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _adQuery: AppDataQuery,
    private _adService: AppDataService,
    private authQuery: AuthQuery,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthDataService,
    private _snackBar: MatSnackBar,
    private journalService: JournalService,
    private settingsService: SettingsService
  ) {}

  ngOnInit(): void {
    // init the forms
    this.createForms();

    // get the stammdaten
    this.getStammdaten();
  }

  /**
   * get the stammdaten
   */
  getStammdaten() {
    console.log('do transfer');

    /* BUG BUG BUG -- we need some kind of security
    let request = {
      api_key: this._config.getConfig().api_key,
      api_baseurl: this._config.getConfig().api_baseurl,
      company_id: this._config.getConfig().company_id,
      person_id: this._config.getConfig().person_id,
    };
    */

    let requestData = {
      api_key: new Date().getTime(),
      //api_baseurl: this._config.getConfig().api_baseurl,
      //company_id: this._config.getConfig().company_id,
      //person_id: this._config.getConfig().person_id,
      do: 'getStammdaten',
    };

    this.settingsService.getSettings().subscribe(
      (response: Settings) => {
        //next() callback
        console.log('response received');
        console.log(response);

        this.settings = response;
        this.frmVSettings.setValue(this.settings);

        // set the date
      },
      (error) => {
        //error() callback
        console.error('Request failed with error');
        //this.errorMessage = error;
      },
      () => {
        //complete() callback
        console.log('Request completed'); //This is actually not needed
      }
    );
  }

  private createForms() {
    // Legacy VSTV settings form (keeping for backward compatibility)
    this.frmVSettings = this.formBuilder.group({
      EMPFANGER: ['', Validators.required],
      SENDER: ['', Validators.required],
      GEMEINDE: ['', Validators.required],
      TATORTART: ['', Validators.required],
      LANDESKENNZEICHEN: ['', Validators.required],
      WAHRNEHMUNG: ['', Validators.required],
      VSTV_PRE_NUMMER: ['', Validators.required],
      UNTERZEICHNER: ['', Validators.required],
      BEARBEITER: ['', Validators.required],
      TAGE_ZUR_ANZEIGE: [0, Validators.required],
      VOR_TEXTBAUSTEIN: [''],
      NACH_TEXTBAUSTEIN: [''],
    });

    // Password change form
    this.passwordForm = this.formBuilder.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8), this.passwordValidator]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });

    // General settings form
    this.generalSettingsForm = this.formBuilder.group({
      emailNotifications: [true],
      pushNotifications: [false],
      weeklySummary: [true],
      darkMode: [false],
      compactView: [false],
      language: ['de'],
      analytics: [true],
      cookies: [true],
      sessionTimeout: [30, [Validators.min(5), Validators.max(480)]],
      autoSave: [true]
    });
  }

  // Custom password validator
  private passwordValidator(control: AbstractControl): {[key: string]: any} | null {
    const value = control.value;
    if (!value) return null;

    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumeric = /[0-9]/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    const valid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar;
    return valid ? null : { 'passwordRequirements': true };
  }

  // Password match validator
  private passwordMatchValidator(control: AbstractControl): {[key: string]: any} | null {
    const newPassword = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');

    if (!newPassword || !confirmPassword) return null;

    return newPassword.value === confirmPassword.value ? null : { 'passwordMismatch': true };
  }

  /**
   * sync the settings to the server
   */
  saveSettings() {
    console.log('save  Settings');

    var username = this.authQuery.name;
    var userid = this.authQuery.userid;
    var token = this.authQuery.access_token;

    let data = {
      username: username,
      uid: userid,
      token: token,
      data: this.frmVSettings.value,
    };

    this.settingsService
      .syncSettings(data)
      .pipe(
        finalize(() => {
          this.frmVSettings.markAsPristine();
        })
      )
      .subscribe(
        (data) => {
          //console.log(data);

          this._snackBar.open('Änderungen erfolgreich durchgeführt', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
            panelClass: 'awesome-snackbar',
          });
        },
        (error) => {
          // show error notification alert
          this._snackBar.open('Fehler aufgetreten', 'Schließen', {
            horizontalPosition: 'center',
            verticalPosition: 'top',
            duration: 3000,
          });
        }
      );
  }

  /**
   * Change user password
   */
  changePassword() {
    if (this.passwordForm.valid) {
      const passwordData = this.passwordForm.value;
      
      // Here you would typically call a service to change the password
      console.log('Changing password...', passwordData);
      
      // Simulate API call
      setTimeout(() => {
        this._snackBar.open('Passwort erfolgreich geändert', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
        });
        this.passwordForm.reset();
      }, 1000);
    }
  }

  /**
   * Handle file selection for profile image
   */
  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        this._snackBar.open('Bitte wählen Sie eine Bilddatei aus', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
        });
        return;
      }

      // Validate file size (2MB max)
      if (file.size > 2 * 1024 * 1024) {
        this._snackBar.open('Datei ist zu groß. Maximale Größe: 2MB', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
        });
        return;
      }

      this.selectedFile = file;
      
      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.profileImageUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  /**
   * Upload profile image
   */
  uploadProfileImage() {
    if (this.selectedFile) {
      // Here you would typically call a service to upload the image
      console.log('Uploading profile image...', this.selectedFile);
      
      // Simulate API call
      setTimeout(() => {
        this._snackBar.open('Profilbild erfolgreich hochgeladen', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
        });
        this.selectedFile = null;
      }, 1000);
    }
  }

  /**
   * Remove profile image
   */
  removeProfileImage() {
    this.profileImageUrl = null;
    this.selectedFile = null;
    
    // Reset file input
    const fileInput = document.getElementById('profileImage') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    this._snackBar.open('Profilbild entfernt', 'Schließen', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 3000,
    });
  }

  /**
   * Save general settings
   */
  saveGeneralSettings() {
    if (this.generalSettingsForm.valid) {
      const settings = this.generalSettingsForm.value;
      
      // Here you would typically call a service to save the settings
      console.log('Saving general settings...', settings);
      
      // Simulate API call
      setTimeout(() => {
        this._snackBar.open('Einstellungen erfolgreich gespeichert', 'Schließen', {
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000,
        });
      }, 1000);
    }
  }
}
